import { useFormikContext } from 'formik';
import React, { useEffect, useRef } from 'react';

type FormDirtyTrackerProps = {
  onDirtyChange?: (dirty: boolean) => void;
  submitRef?: React.MutableRefObject<(() => Promise<boolean | void>) | null>;
};

export const FormDirtyTracker: React.FC<FormDirtyTrackerProps> = ({
  onDirtyChange,
  submitRef,
}) => {
  const { dirty, submitForm, validateForm } = useFormikContext();
  const onDirtyChangeRef = useRef(onDirtyChange);
  onDirtyChangeRef.current = onDirtyChange;

  useEffect(() => {
    onDirtyChange?.(dirty);
  }, [dirty]);

  useEffect(() => {
    return () => {
      onDirtyChangeRef.current?.(false);
    };
  }, []);

  useEffect(() => {
    if (!submitRef) return;
    submitRef.current = async () => {
      const errors = await validateForm();
      if (Object.keys(errors).length > 0) {
        await submitForm(); // marks all fields as touched to surface validation errors
        return false;
      }
      return submitForm();
    };
    return () => {
      submitRef.current = null;
    };
  }, [submitForm, submitRef, validateForm]);

  return null;
};
